import React from 'react';
import { Line } from 'react-chartjs-2';

type State = {
  labels: object;
  datasets: any;
};
const TimeLineConversationList = (State: any) => {
  State = {
    labels: [
      '10AM-11AM',
      '11AM-12PM',
      '12PM-1PM',
      '1PM-2PM',
      '2PM-3PM',
      '3PM-4PM',
      '4PM-5PM',
      '5PM-6PM',
    ],
    datasets: [
      {
        label: 'Total Conversation',
        fill: false,
        lineTension: 0.5,
        backgroundColor: 'rgba(75,192,192,1)',
        borderColor: 'rgba(0,0,0,1)',
        borderWidth: 2,
        data: [65, 59, 80, 81, 56],
      },
    ],
  };

  return (
    <div style={{ width: '50vw' }}>
      <Line data={State} />
    </div>
  );
};
export default TimeLineConversationList;
